import User from 'src/models/Users/User'
import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, UserState} from '@/types/store/states'
import {RawUser} from '@/types/entity/RawUser'
import {API, LANG} from '@/constants'
import globvars from '@/lib/globvars'
import auth, {setRefreshToken} from '@/services/auth'
import router from '@/routes'
import {beforeLoginPath} from '@/routes/guard'
import config from '@/config'
// @ts-ignore
import Cookies from 'js-cookie'

const store: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    user: false
  },
  getters: {
    getUser: state => (data: RawUser) => {
      Vue.set(state, 'user', new User(data))
      return state.user
    }
  },
  mutations: {
    user: (state, user) => {
      state.user = user
    }
  },
  actions: {
    async login (context, data) {
      try {
        let response = await context.dispatch('apiRequest', {url: API.auth.login, data}, {root: true})
        const hasAnotherLang = response.user.lang;

        if (hasAnotherLang) {
          Cookies.set('lang_checked', hasAnotherLang);
        }

        auth.setToken(response.jwt)
        auth.setRefreshToken(response.refresh)
        await context.dispatch('loadUser', true)
        const Ws = globvars.get('ws')
        const token = auth.readToken()
        const uid = context.state.user && context.state.user.id
        if (token && uid) {
          Ws.connect(token, uid)
        }
        // set token
        // describe
        // connect
        return beforeLoginPath || '/';
      } catch (error) {
        throw error;
      }
    },
    async logout (context) {
      try {
        context.commit('user', false);
        context.commit('preheaders/closeAll', {}, {root: true})
        globvars.remove('user');
        auth.clearToken();
        auth.clearRefreshToken();
        const Ws = globvars.get('ws')
        console.log('LOG: logout -> Ws', Ws)
        Ws.disconnect()
      } catch (error) {
        throw error;
      }
    },
    async loginRefresh (context, refresh) {
      try {
        auth.clearToken()
        const response = await context.dispatch('apiRequest', {
          url: API.auth.refresh,
          data: {refresh},
          refresh: true
        }, {root: true})
        auth.setToken(response.jwt)
        const Ws = globvars.get('ws')
        Ws.disconnect()
        const uid = context.state.user && context.state.user.id
        if (response.jwt && uid) {
          Ws.connect(response.jwt, uid)
        }
      } catch (error) {
        throw error;
      }
    },
    async loadUser (context) {
      try {
        const response = await context.dispatch('apiRequest', {
          method: API.user.me,
          flag: 'silent'
        }, {root: true})
        let user = context.getters.getUser(response.user)
        globvars.set('user', user.id)

        const responseLang = response.user && response.user.lang !== 'undefined' && response.user.lang;

        if (responseLang) {
          // Cookies.set('lang_checked', responseLang);
        }

        return user;
      } catch (error) {
        console.error('loadUser error', error)
        router.push('/login')
        context.dispatch('logout')
        throw error;
      }
    },
    async setPassword (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.user.password,
        data
      }, {root: true})
      console.log('LOG: setPassword -> response', response)
    },
    async userUpdate (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.user.userUpdate,
        data
      }, {root: true})
      console.log('LOG: setPassword -> response', response)
    },
    async userProfileUpdate (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: 'cproc/staff/profile/update',
        data,
        flag: 'silent'
      }, {root: true})
      console.log('LOG: userProfileUpdate -> response', response)
    },
    async upicRemove (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.user.upicRemove,
        data
      }, {root: true})
      console.log('LOG: setPassword -> response', response)
    },
    async getCode (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.msgr.getCode,
        data
      }, {root: true})
      return response;
    },
    async unbind (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.msgr.unbind,
        data
      }, {root: true})
      return response;
    },
  }
}

export default store
